import { render } from "./MerchPreview.vue?vue&type=template&id=700ec48f&scoped=true"
import script from "./MerchPreview.vue?vue&type=script&lang=js"
export * from "./MerchPreview.vue?vue&type=script&lang=js"

import "./MerchPreview.vue?vue&type=style&index=0&id=700ec48f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700ec48f"]])

export default __exports__